import styled from "styled-components";

export const Main = styled.div`
   width: 600px;
   height: 550px;

   > .title {
      display: flex;
      align-items: center;

      .icon {
         display: flex;
         align-items: center;
         justify-content: center;
         width: 60px;
         height: 60px;
         background-color: rgb(250, 250, 250);
         border: 1px solid rgb(232, 232, 236);
         border-radius: 5px;
         margin-right: 20px;
         font-size: 25px;
      }
      h3 {
         font-weight: 500;
      }
      p {
         opacity: 0.8;
         margin-top: 3px;
      }
   }
   .options {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;

      .select {
         width: 315px;
      }
      > div {
         display: flex;
      }
      button {
         font-size: 15px;
         height: 32.4px;
         white-space: nowrap;
         padding: 0 15px;
         border-radius: 5px;
         border: 1px solid transparent;
         cursor: pointer;
         transition: all .2s ease-in-out;

         &:first-of-type {
            margin-right: 7.5px;
            opacity: 0.65;
            background-color: transparent;
            border-color: rgba(30, 39, 46, 0.2);
            width: 112.48px;
            

            &:hover {
               opacity: 1;
               background-color: rgb(240, 240, 240);
               border-color: transparent;
            }
         }
         &:last-of-type {
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #1E272E;
            color: #fff;
            width: 80px;

            svg {
               font-size: 18px;
               margin-right: 5px;
            }
            &:hover {
               opacity: 0.9;
            }
            &:disabled {
               opacity: 0.6;
               cursor: default;
            }
         }
      }
   }
   .code {
      display: flex;
      flex-direction: column;
      margin-top: 15px;
      border-radius: 5px;
      overflow: hidden;

      .title {
         display: flex;
         align-items: center;
         justify-content: space-between;
         background-color: rgb(31, 41, 55);
         color: #eee;
         height: 40px;
         font-size: 15px;
         padding: 0 10px 0 20px;

         .copy {
            cursor: pointer;
            padding: 2.5px 10px;
            font-size: 14px;
            border-radius: 5px;
            transition: all .2s ease-in-out;

            svg {
               margin-right: 7.5px;
            }
            &:hover {
               background-color: #2e3d52;
            }
         }
      }
      pre {
         margin: 0 !important;
         font-size: 15px;
         height: calc(550px - 60px - 32.4px - 20px - 15px - 40px - 40px);
      }
      &.withResult pre {
         height: calc(550px - 60px - 32.4px - 20px - 15px - 40px - 40px - 107.5px);
      }
   }
   .result {
      background: rgb(17, 27, 39);
      margin-top: 7.5px;
      height: 100px;
      border-radius: 5px;
      color: #fff;
      padding: 15px;
      font-size: 15px;
      font-weight: 300;
      overflow: auto;

      .points {
         display: flex;
         align-items: center;

         span {
            width: 13px;
            height: 13px;
            margin-right: 7.5px;
            border-radius: 50%;

            &:first-of-type { background-color: #F05252; }
            &:nth-of-type(2) { background-color: #E3A008; }
            &:last-of-type { background-color: #0E9F6E; }
         }
      }
      pre {
         margin-top: 15px;
         white-space: nowrap;
      }
   }
`;